import React, { useState } from 'react'
import CoursePrompt from './course-prompt'
import FacilitatorPrompt from './facilitator-prompt'
import useCurrentUser from '../../../hooks/use-current-user'
import useUserCourseRatings from '../../../hooks/use-user-course-ratings'
import useUserFacilitatorRatings from '../../../hooks/use-user-facilitator-ratings'
import { first } from 'lodash'
import Card from './card'

const RatingPrompt = () => {
    const { id } = useCurrentUser()
    
    const {
        userFacilitatorRatings,
        isLoading: isLoadingFacilitatorRatings,
    } = useUserFacilitatorRatings({
        limit: 1,
        completed: false,
        userId: id,
    })

    const {
        userCourseRatings,
        isLoading: isLoadingCourseRatings,
    } = useUserCourseRatings({
        limit: 1,
        completed: false,
        userId: id,
    })
    /*
   const userCourseRatings = []
   const isLoadingCourseRatings = false
*/


    if (isLoadingCourseRatings || isLoadingFacilitatorRatings) {
        return null
    }

    const userCourseRating = first(userCourseRatings)
    const userFacilitatorRating = first(userFacilitatorRatings)

    if (userCourseRating) {
        return (<Card><CoursePrompt userRating={userCourseRating} userId={id} /></Card>)
    }

    if (userFacilitatorRating) {
        return (<Card><FacilitatorPrompt userRating={userFacilitatorRating} userId={id} /></Card>)
    }

    return null

}

export default RatingPrompt